import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";


export const crearFestivo = async (nombre, fecha, color = "primary") => {
    try {
        const data = { nombre, fecha, color };
        const resp = await axios.post(`${API_URL}/administrar/festivos`, data, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};


export const listarFestivos = async () => {
    try {
        const resp = await axios.get(`${API_URL}/administrar/festivos`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};


export const eliminarFestivo = async (fecha) => {
    try {
        const resp = await axios.delete(`${API_URL}/administrar/festivos/${fecha}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
